import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Outlet, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { Flex, VFlex } from '@/components/base';
import { useResizeHandle } from '@/hooks/useResizeHandle';

import { TaxonomyProvider } from '../../context/TaxonomyContext';
import { TaxonomyDragProvider } from '../../context/TaxonomyDragContext';
import { TopicFeedbackListProvider } from '../../context/TopicDetailContext';
import FeedbackDragLayer from './FeedbackDragLayer/FeedbackDragLayer';
import Topic2DetailSidebar from './Topic2DetailSidebar/Topic2DetailSidebar';

const Topic2DetailLayout = () => {
  const { taxonomy_alias, topic_alias } = useParams();
  const { isResizing, elementRef, handleMouseDown } = useResizeHandle({
    initialWidth: 400,
    minWidth: 200,
    maxWidth: () => window.innerWidth * 0.6,
  });

  if (!taxonomy_alias) throw new Error('Invalid taxonomy alias');
  return (
    <TaxonomyProvider key={taxonomy_alias} taxonomyAlias={taxonomy_alias}>
      <TaxonomyDragProvider
        taxonomyAlias={taxonomy_alias}
        topicAlias={topic_alias}
      >
        <TopicFeedbackListProvider
          taxonomyAlias={taxonomy_alias}
          topicAlias={topic_alias}
        >
          <DndProvider backend={HTML5Backend}>
            <Style>
              <VFlex ref={elementRef} className="tree-area">
                <Topic2DetailSidebar
                  taxonomyAlias={taxonomy_alias}
                  topicAlias={topic_alias}
                />
                <ResizeHandle
                  onMouseDown={handleMouseDown}
                  className={isResizing ? 'resizing' : ''}
                />
              </VFlex>
              <VFlex f={1} g={40} className="detail-area" key={topic_alias}>
                <Outlet />
              </VFlex>
            </Style>
            <FeedbackDragLayer />
          </DndProvider>
        </TopicFeedbackListProvider>
      </TaxonomyDragProvider>
    </TaxonomyProvider>
  );
};

const Style = styled(Flex)`
  flex: 1;
  max-width: 100vw;
  height: 100%;
  .tree-area {
    position: relative;
    overflow: auto;
    overflow-x: hidden;
    min-width: 200px;
    max-width: 60vw;
  }
  .detail-area {
    display: block;
    width: 100%;
    overflow: auto;
  }
`;

const ResizeHandle = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 4px;
  height: 100%;
  cursor: col-resize;
  background-color: transparent;
  transition: background-color 0.2s ease;

  &:hover,
  &.resizing {
    background-color: rgba(0, 0, 0, 0.1);
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: -2px;
    width: 8px;
    height: 100%;
  }
`;

export default Topic2DetailLayout;
